import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Modal,
  TextField,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { dynamicPage_details } from "../auth/service";
import { toast } from "react-toastify";

const AddCategoryAccordian = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverId, setPopoverId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    pageName: "",
  });

  const [pageNameError, setPageNameError] = useState("");

  // ---------------- Load Data ----------------
  const fetchCategories = async () => {
    setLoading(true);
    const data = await dynamicPage_details();
    setCategories(
      data.map((item) => ({
        _id: item._id,
        pageName: item.page_name,
      }))
    );
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // ---------------- Handlers ----------------
  const handleOpenAdd = () => {
    setFormData({ pageName: "" });
    setOpenModal(true);
  };

  // ✅ UPDATED: Navigate to Page Details instead of creating page here
  const handleAddPage = () => {
    const enteredName = formData.pageName.trim().toLowerCase();

    if (!enteredName) {
      toast.error("Please enter page name");
      return;
    }

    // 🔴 Duplicate check (case-insensitive)
    const isDuplicate = categories.some(
      (item) => item.pageName.trim().toLowerCase() === enteredName.toLowerCase()
    );

    if (isDuplicate) {
      setPageNameError("Page name already present");
      return;
    }

    // if (!formData.pageName.trim()) {
    //   toast.error("Please enter page name");
    //   return;
    // }

    // Navigate to details page
    setPageNameError("");

    navigate(`/dashboard/PageCategoryDetails/new`, {
      state: { pageName: enteredName },
    });
    setOpenModal(false);
  };

  // ---------------- UI ----------------
  return (
    <>
      <Accordion expanded>
        <AccordionSummary>
          <Typography fontWeight={600} fontSize="1.6rem">
            Page Details
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Button variant="contained" sx={{ mb: 2 }} onClick={handleOpenAdd}>
            + Add Page
          </Button>

          {loading ? (
            <CircularProgress />
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Page Name</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {categories.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No pages found
                      </TableCell>
                    </TableRow>
                  ) : (
                    [...categories].reverse().map((item) => (
                      <TableRow key={item._id}>
                        <TableCell>{item._id}</TableCell>
                        <TableCell>{item.pageName}</TableCell>
                        <TableCell>
                          <MoreVertIcon
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => {
                              setAnchorEl(e.currentTarget);
                              setPopoverId(item._id);
                            }}
                          />

                          <Popover
                            open={popoverId === item._id}
                            anchorEl={anchorEl}
                            onClose={() => {
                              setAnchorEl(null);
                              setPopoverId(null);
                            }}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                          >
                            <Typography
                              sx={{ p: 1, cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/dashboard/PageCategoryDetails/${item._id}`,
                                  { state: { pageName: item.pageName } }
                                )
                              }
                            >
                              <RemoveRedEyeIcon sx={{ fontSize: 16, mr: 1 }} />
                              Details
                            </Typography>
                          </Popover>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>

      {/* ---------------- Modal ---------------- */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            p: 3,
            borderRadius: 2,
            width: 400,
          }}
        >
          <Typography fontWeight={600} mb={2}>
            Add Page
          </Typography>

          <TextField
            autoFocus
            fullWidth
            size="small"
            label="Page Name"
            value={formData.pageName}
            error={Boolean(pageNameError)}
            helperText={pageNameError}
            // inputProps={{
            //   maxLength: 25, // ✅ restrict to 25 characters
            // }}
            onChange={(e) => {
              // const value = e.target.value;
              const inputValue = e.target.value;

              // ❌ if numbers present
              if (/\d/.test(inputValue)) {
                setPageNameError("Numbers are not allowed");
                return;
              }

              if (inputValue.length > 25) {
                setPageNameError("Maximum length is 25 characters");
                return;
              }

              const lowerCaseValue = inputValue.toLowerCase();

              // ✅ valid input
              setPageNameError("");
              setFormData({ ...formData, pageName: lowerCaseValue });
            }}
          />

          <Box display="flex" justifyContent="flex-end" mt={3}>
            <Button
              variant="outlined"
              sx={{ mr: 1 }}
              onClick={() => {
                setOpenModal(false);
                setPageNameError("");
              }}
            >
              Cancel
            </Button>
            {/* ✅ UPDATED: use handleAddPage */}
            <Button variant="contained" onClick={handleAddPage}>
              Add page name
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AddCategoryAccordian;
